export const routes = {
  main: {
    base: "/",
    languageDetection: "/language-detection",
    languageDetection2: "/language-detection2",
    chooseLanguage: "/choose-language",
    aboutUs: "/about-us",
    articles: "/articles",
    articleDetail: (id: string) => `/articles/${id}`,
    privacyPolicy: "/privacy-policy",
    savedArticles: "/saved-articles",
  },
  dashboard: {
    articles: (id?: string) => {
      const base = "dashboard/articles";

      return {
        overview: `/${base}`,
        new: `/${base}/new`,
        detail: `/${base}/${id}`,
      };
    },
    tags: (id?: string) => {
      const base = "dashboard/tags";

      return {
        overview: `/${base}`,
        new: `/${base}/new`,
        detail: `/${base}/${id}`,
      };
    },
    users: (id?: string) => {
      const base = "dashboard/users";

      return {
        overview: `/${base}`,
        new: `/${base}/new`,
        detail: `/${base}/${id}`,
      };
    },
    organisations: (id?: string) => {
      const base = "dashboard/organisations";

      return {
        overview: `/${base}`,
        new: `/${base}/new`,
        detail: `/${base}/${id}`,
      };
    },
  },
};
